import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import SettingsPage from './SettingsPage';

export default flowRight(withVerificationGuard, withAuthGuard())(SettingsPage);
